import { buildHtml , ContentRoute,RouteSlotInput  } from '@caritas/ui';

export function mapIframeBlock(
  input: BlockIframeFragment,
): RouteSlotInput<typeof ContentRoute, 'body', 'iframe'> {
  return {
    key: 'iframe',
    input: () => [
      {
        url: input.media?.url || '',
        Html: input.media?.embedHtml
          ? buildHtml(input.media.embedHtml)
          : undefined,
        embedType:
          input.media?.embedType === 'unknown' || !input.media?.embedType
            ? 'default'
            : input.media?.embedType,
      },
      200,
    ],
  };
}
